export enum WebAwesomeComponent {
  Button = 'wa-button',
  ButtonGroup = 'wa-button-group',
  Details = 'wa-details',
  Dialog = 'wa-dialog',
  Dropdown = 'wa-dropdown',
  DropdownItem = 'wa-dropdown-item',
  Icon = 'wa-icon',
  Input = 'wa-input',
  Spinner = 'wa-spinner',
  Tooltip = 'wa-tooltip',
  Tree = 'wa-tree',
  TreeItem = 'wa-tree-item',
}

function tryLoadDependency(doc: Document, component: WebAwesomeComponent): void {
  if (doc?.getElementsByTagName(component)?.length === 0) {
    const newElement = document.createElement(component)
    newElement.setAttribute('style', 'display: none')
    newElement.textContent = 'AA autoloaded'
    doc.body.appendChild(newElement)
  }
}

export function tryLoadDependencies(doc: Document, components: WebAwesomeComponent[]): void {
  components.forEach((component) => {
    tryLoadDependency(doc, component)
  })
}

export function tryLoadPropertyStyles(shadow: ShadowRoot, cssFileName: string): void {
  const componentCssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/components/${cssFileName}`;
  
  // Check if already loaded to avoid duplicates
  if (!document.querySelector(`link[href="${componentCssUrl}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = componentCssUrl;
    shadow.appendChild(link);
  }
};